import { render, staticRenderFns } from "./Service_Page.vue?vue&type=template&id=ff040344&scoped=true"
import script from "./Service_Page.vue?vue&type=script&lang=js"
export * from "./Service_Page.vue?vue&type=script&lang=js"
import style0 from "./Service_Page.vue?vue&type=style&index=0&id=ff040344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff040344",
  null
  
)

export default component.exports